import { isNullOrUndefined } from 'util';
import { ReportService } from 'src/app/services/report.service';
import { Component, OnInit } from '@angular/core';
import { EncrdecrService } from '../../Auth/encrdecr.service';
import { CustomLoaderService } from 'src/app/services/custom-loader.service';

@Component({
  selector: 'app-invoicegenerate',
  templateUrl: './invoicegenerate.component.html',
  styleUrls: ['./invoicegenerate.component.scss']
})
export class InvoicegenerateComponent implements OnInit {
  G_SubbrokerId: any;
  InvoiceNo: any;
  PaymentDate: any;
  BillTo: any;
  Discount: any;
  Deduction: any;
  Amount: any;
  TotalInc: any;
  AmountGST: any;
  BilledAmount: any;
  TaxAmount: any;
  TaxAmtGst: any;
  SGST: any;
  CGST: any;
  GSTNO: any;

  constructor(
    private reportservice: ReportService,
    private Loader: CustomLoaderService,
    private EncrdecrService: EncrdecrService
  ) {}

  ngOnInit() {
    debugger;
    this.G_SubbrokerId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('F44sGAGh2xwkpUL')
    );
    if (this.G_SubbrokerId != '' && !isNullOrUndefined(this.G_SubbrokerId)) {
      this.Loader.show();
      this.GetInvoiceDetail(this.G_SubbrokerId);
    }
  }

  print() {
    window.print();
  }
  GetInvoiceDetail(subbrokerId: any) {
    this.reportservice.GetInvoiceDetails(subbrokerId).subscribe((data) => {
      if (data != null) {
        if (
          data.Message != null &&
          data.Message != '' &&
          data.Message.indexOf('Not Authorized') > -1
        ) {
          this.Loader.hide();
          return;
        } else {
          this.InvoiceNo = data.ArrayOfResponse[0].InvoiceNo;
          this.PaymentDate = data.ArrayOfResponse[0].PaymentDate;
          this.BillTo = data.ArrayOfResponse[0].BillTo;
          this.Discount = data.ArrayOfResponse[0].Discount;
          this.Deduction = data.ArrayOfResponse[0].Deduction;
          this.Amount = data.ArrayOfResponse[0].Amount;
          this.TotalInc = data.ArrayOfResponse[0].TotalInc;
          this.AmountGST = data.ArrayOfResponse[0].AmountGST;
          this.BilledAmount = data.ArrayOfResponse[0].BilledAmount;
          this.TaxAmount = data.ArrayOfResponse[0].TaxAmount;
          this.TaxAmtGst = data.ArrayOfResponse[0].TaxAmtGst;
          this.SGST = data.ArrayOfResponse[0].SGST;
          this.CGST = data.ArrayOfResponse[0].CGST;
          this.GSTNO = data.ArrayOfResponse[0].GSTNO;
          this.Loader.hide();
        }
      }
    });
    this.Loader.hide();
  }
}
